import { AuthConfig } from 'angular-oauth2-oidc';

export const environment = {
	production: true,
	mobile: false,
	develop: false,
	home: 'https://clickartest-temp.clickar.com/',
	baseApiUrl: 'https://apitest-temp.clickar.com/b2b',
    baseImageUrl: 'https://apitest-temp.clickar.com',
	k8sApiUrl: 'https://k8s-test.clickar.com/b2b',
	languages: ['en-IT', 'it-IT', 'fr-BE', 'nl-BE', 'en-BE', 'de-DE', 'en-DE', 'es-ES', 'en-ES',
		'nl-NL', 'en-NL', 'fr-FR', 'en-FR', 'pl-PL', 'en-PL', 'pt-PT', 'en-PT', 'en-LU', 'fr-LU', 'de-AT', 'en-AT'],
	translatePrefix: 'https://clickartest-temp.clickar.com/assets/i18n',
	clickarCom: 'https://test.clickar.com',
	mqtt: {
		host: 'mqtest-temp.clickar.com',
		port: 443,
		username: 'user_reader',
		password: 'R&ad/r.Le^sys01!',
		topic: 'Clickar.biz_{0}_{1}'
	}
};

export const authConfig: AuthConfig = {
	issuer: 'https://idfed-preprod.mpsa.com:443',
	redirectUri: 'https://clickartest-temp.clickar.com',
	oidc: true,
	clientId: 'CIGKHCJSIIOIQLNENIQAAZPOQYECTZMU',
	responseType: 'code',
	strictDiscoveryDocumentValidation: false,
	scope: 'openid profile prd:rmk',
	requireHttps: true,
	showDebugInformation: true
};
